import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { generateFormattedTime } from 'reactjs/components/utility';

const ProductFundraisingTimer = ({ className, endTime, timeIsUpCallback }) => {
  const now = dayjs(new Date());
  const end = dayjs(endTime);
  const diff = end.diff(now, 'second');
  const [seconds, setSeconds] = useState(diff > 0 ? diff : 0);

  useEffect(() => {
    const timer = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds === 0) {
          clearInterval(timer);
          return 0;
        }
        return prevSeconds - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const { number, unit } = generateFormattedTime(seconds);

  if (seconds === 0) {
    timeIsUpCallback();
    return null;
  }

  return (
    <span className={className}>
      {number}
      <small style={{ marginLeft: '1px', fontSize: '0.9em' }}>{unit}</small>
    </span>
  );
};

ProductFundraisingTimer.propTypes = {
  className: PropTypes.string,
  endTime: PropTypes.string.isRequired,
  timeIsUpCallback: PropTypes.func.isRequired
};

ProductFundraisingTimer.defaultProps = {
  className: ''
};

export default ProductFundraisingTimer;
